<template>
	<div class="formulate-async-select">
		<v-select
			ref="select"
			:class="`formulate-input-element formulate-input-element--${context.type}`"
			:data-type="context.type"
			:modelValue="context._value"
			@update:modelValue="handleInput"
			:options="context.options"
			:reduce="(x) => x.value"
			v-bind="context.attrs"
			:filterable="false"
			label="label"
			@close="onClose"
			@search="onSearch"
		/>

		<slot name="after"></slot>
	</div>
</template>


<script src="./FormulateAsyncSelect.js"></script>
